"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 29/01/2019
 */

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * TODO
 *
 * @author JMr
 */


var LocalisationRow =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(LocalisationRow, _DomainObject_1$Domai);

  function LocalisationRow(id, locale, key, value) {
    var _this;

    _classCallCheck(this, LocalisationRow);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LocalisationRow).call(this));
    _this.id = id;
    _this.locale = locale;
    _this.key = key;
    _this.value = value;
    return _this;
  }

  return LocalisationRow;
}(DomainObject_1.DomainObject);

exports.LocalisationRow = LocalisationRow;